import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Sidebar from './Sidebar';

import 'swagger-ui-react/swagger-ui.css';
import './App.css';
import ApiDefinition from './ApiDefinition';

const services =
  process.env.NODE_ENV === 'development'
    ? require('./services-dev.json')
    : require('./services.json');

const App = () => {
  return (
    <div className="App">
      <Sidebar apis={services} />
      <Switch>
        <Route exact path="/">
          <div className="App-information">
            <p>
              <span role="img" aria-label="Pointing left">
                👈
              </span>{' '}
              Please select an API from the left sidebar.
            </p>
          </div>
        </Route>
        <Route path="/services/:namespace/:name/:version">
          <ApiDefinition />
        </Route>
      </Switch>
    </div>
  );
};

export default App;
